import {ActionItem, ApiQuery} from "@stylehaven/components";
import {combineLatest, isObservable, Observable, Observer, of} from "rxjs";

export type BatchActionItemCreateFn = (query: ApiQuery, observer: Observer<any>) => ActionItem | Observable<ActionItem>;

export interface BatchActionItemFactory {
    createFn: BatchActionItemCreateFn;
}

export function createBatchActionItems(
    factories: BatchActionItemFactory[],
    query: ApiQuery,
    observer: Observer<any>
): Observable<ActionItem[]> {
    if (!factories.length) {
        return of([]);
    }
    return combineLatest(
        factories.map(factory => {
            const item = factory.createFn(query, observer);
            return isObservable(item) ? item : of(item);
        })
    );
}
